import script from "./followStatusCom.vue?vue&type=script&lang=ts&setup=true"
export * from "./followStatusCom.vue?vue&type=script&lang=ts&setup=true"

import "./followStatusCom.vue?vue&type=style&index=0&id=2bd7b642&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd7b642"]])

export default __exports__